module.exports = __webpack_public_path__ + "media/images/room_menu_icon/discount_ticket_infos-b65e5586b46a39286c96eeb694bf1ebb.png";